export const ALL_MOBILE_ROUTES = {
  AUTH: {
    LOGIN: `/${APP_ENV}/login`,
    SIGN_UP: `/${APP_ENV}/signup`,
    RESET_PASSWORD: `/${APP_ENV}/reset-password`,
    DEMO_CREATION: `/${APP_ENV}/demo-creation`,
    DEMO_COMPLETION: `/${APP_ENV}/demo-completion`,
    EXPERIENCE_DEMO_CREATION: `/${APP_ENV}/experience-demo-creation`,
    EXPERIENCE_DEMO_COMPLETION: `/${APP_ENV}/experience-demo-completion`,
    EXPERIENCE_DEMO_RESET_PASSWORD: `/${APP_ENV}/experience-demo-reset-password`
  },

  BOTTOM_TAB: {
    INDEX: `/${APP_ENV}/home`,
    MARKETS: `/${APP_ENV}/market`,
    TRADE: `/${APP_ENV}/trade`,
    INFO: `/${APP_ENV}/info`,
    ASSETS: `/${APP_ENV}/assets`
  },

  MAIN: {
    SIGNAL: `/${APP_ENV}/signal`,
    SEARCH: `/${APP_ENV}/search`,
    ACCOUNT: `/${APP_ENV}/account`,
    COPY_TRADE: `/${APP_ENV}/copytrade`,
    EDIT_ORDER: `/${APP_ENV}/edit/order`,
    TRANSACTION: `/${APP_ENV}/transactions`,
    NOTIFICATIONS: `/${APP_ENV}/notifications`,
    NOTIFICATIONS_ORDER: `/${APP_ENV}/notifications/order`,
    DEMO_CREATION: `/${APP_ENV}/demo-creation`,
    DEMO_COMPLETION: `/${APP_ENV}/demo-completion`,
    ONE_CLICK_TRADING_TNC: `/${APP_ENV}/one-click-tnc`,
    ONE_CLICK_TRADING_CONFIRMATION: `/${APP_ENV}/one-click-confirmation`
  },

  ACCOUNT: {
    INDEX: `/${APP_ENV}/account`,
    ABOUT: `/${APP_ENV}/account/about`,
    SUPPORT: `/${APP_ENV}/account/support`,
    SUPPORT_DETAIL: `/${APP_ENV}/account/support/details`,
    SUPPORT_REPORT: `/${APP_ENV}/account/support/report`,
    LANGUAGES: `/${APP_ENV}/account/languages`,
    APPEARANCE: `/${APP_ENV}/account/appearances`,
    BIOMETRICS: `/${APP_ENV}/account/biometrics`,
    NOTIFICATIONS: `/${APP_ENV}/account/notifications`,
    LINKED_DEVICES: `/${APP_ENV}/account/devices`,
    SWITCH_ACCOUNT_CRM: `/${APP_ENV}/account/crm/switch-account`,
    SWITCH_ACCOUNT_METATRADER: `/${APP_ENV}/account/metatrader/switch-account`,
    CHANGE_PASSWORD: `/${APP_ENV}/account/change-password`,
    HELP_SUPPORT: `/${APP_ENV}/account/help-support`
  }
};
